module.exports = __webpack_public_path__ + "static/Screenshot-2019-08-19-16.31.40-6f1ecf0ecc26cf188113edf15a889a7a.png";